import styled from "styled-components";
import { Props } from "./types";

export const Wrapper = styled("div")<Props>`
    position: relative;
    display: inline-flex;
`;
